import { React, useState,useEffect } from "react";
import "./landing.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import image from "./img/switch.png";
import imagebk from "./img/back.png";
import logoutimg from "./img/logout.png";
import Buttons from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {GET_LVCONNECTOR_EACH,GET_LVCONNECTORSAVEDDATA,GET_HARNESSDATA_EACH,CREATE_TEST_ENTRY,CREATE_COMMISSIONREPORT,GET_HARNESSDATA,GET_COMMISSIONDATA,GET_FETCHHVDATA,GET_FETCHLVDATA,GET_FETCHLVCONDATA,GET_FETCHBONDINGDATA,CREATE_LV_CONNECTOR,CREATE_ISOLATIONTEST,CREATE_BONDING,GET_BONDINGSAVEDDATA,GET_BONDING_EACH,GET_ISOLATIONSAVEDDATA,GET_ISOLATION_EACH} from '../../Pages/AppConstant'

function Landing() {
  const [emp_id, setEmp_id] = useState("");
  const [emp_fullname, setEmp_fullname] = useState("");
  const [emp_displayname, setEmp_displayname] = useState("");
  const [grade, setGrade] = useState("");
  const [designation, setDesignation] = useState("");
  const [department, setDepartment] = useState("");
  const [contact, setContact] = useState("");
  const [typeofhire, setTypeofhire] = useState("");
  const [worklocation, setWorklocation] = useState("");
  const [email_id, setEmail_id] = useState("");
  const [doj, setDoj] = useState("");
  const [asset_id, setAsset_id] = useState("");
  const [make, setMake] = useState("");
  const [selectedcategory, setSelectedcategory] = useState("");
  const [serialno, setSerialno] = useState("");
  const [dop, setDop] = useState("");
  const [os, setOs] = useState("");
  const [processor, setProcessor] = useState("");
  const [ram, setRam] = useState("");
  const [hdd, setHdd] = useState("");
  const [model, setModel] = useState("");
  const [isfirsttab, setIsfirsttab] = useState(false);
  const [issecondtab, setIsecondtab] = useState(false);
  const [isthirdtab, setIsthirdtab] = useState(false);
  const [isforthtab, setIsforthtab] = useState(false);
  const [isfifth, setIsfifth] = useState(false);
  const [issixes, setIssixes] = useState(false);
  const [assetlist, setAssetlist] = useState([]);
  const [requestlist, setRequestlist] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedasset, setSelectedasset] = useState([]);
  const [rawdata, setRawdata] = useState([]);
  const [selectedempid, setSelectedempid] = useState("");
  const [selectedemailid, setSelectedemailid] = useState("");
  const [empdata, setEmpdata] = useState("");
  const [dashbaordtab, setDashbaordtab] = useState(true);
  const [step1cr, setStep1cr] = useState("");
  const [step2cr, setStep2cr] = useState("");
  const [step3cr, setStep3cr] = useState("");
  const [step4cr, setStep4cr] = useState("");
  const [step5cr, setStep5cr] = useState("");
  const [lvdataobj, setLvdataobj] = useState([]);
  const [hvdataobj, setHvdataobj] = useState([]);
  const [lvcondataobj, setLvcondataobj] = useState([]);
  const [bondingobj, setBondingobj] = useState([]);
  const [modelselect,setModelselect]= useState([]);
  const [vinval,setvinval]= useState("");
  const [isfirstsub1,setIsfirstsub1]=useState(true)
  const [isfirstsub2,setIsfirstsub2]=useState(false)
  const [isfirstsub3,setIsfirstsub3]=useState(true)
  const [isfirstsublv1,setIsfirstsublv1]=useState(true)
  const [isfirstsublv2,setIsfirstsublv2]=useState(false)
  const [commissiondata,setCommissiondata]= useState([]);
  const [vinumber, setVinumber] = useState("");
  const [harnesssaveddata,setHarnesssaveddata]=useState([])
  const [listlvharnessdata,setListlvharnessdata]=useState([])
  const [idealcondition,setIdealcondition]=useState("")
  const [vb,setVb]=useState("")
  const [vc,setVc]=useState("")
  const [vc2,setVc2]=useState("")
  const [ro,setRo]=useState("")
  const [ro2,setRo2]=useState("")
  const [ro1,setRo1]=useState("")
  const [resistancedata,setResistancedata] = useState("")
  const [bondingmsg,setBondingmsg] = useState("")
  const [savedharnessdata,setSavedharnessdata]=useState([])
  const [lvconnectorsavedlist,setLvconnectorsavedlist]=useState([])
  const [bondingsavedlist,setBondingsavedlist]=useState([])
  const [isolationsavedlist,setIsolationsavedlist]=useState([])
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (
//       !emp_id ||
//       !emp_fullname ||
//       !emp_displayname ||
//       !grade ||
//       !designation ||
//       !department ||
//       !email_id ||
//       !typeofhire ||
//       !worklocation ||
//       !doj
//     ) {
//       alert("Please fill all the fields");
//     } else {
//       getUserData(emp_id);
//     }
//     // Add your form submission logic here
//   };
useEffect(()=>{
  calllvdata()
  callhvdata()
  calllvconnectordata()
  callbondingdata()
},[modelselect])
  const redirectToLogin = () => {
    window.location.href = "/login";
  };
  const redirectTodashboard = () => {
    window.location.href = "/landingPage";
  };

  const handleReset = () => {
    // Reset all state variables here
    setEmp_id("");
    setEmp_fullname("");
    setEmp_displayname("");
    setContact("");
    setGrade("");
    setDesignation("");
    setDepartment("");
  };
  const handleResetasset = () => {
    setAsset_id("");
    setMake("");
    setSelectedcategory("");
    setSerialno("");
    setDop("");
    setOs("");
    setProcessor("");
    setRam("");
    setHdd("");
    setModel("");
  };
  
  const enabletab = (e) => {
    if (e === 1) {
      if (!isfirsttab) {
        setIsfirsttab(true);
        setIsecondtab(false);
        setIsthirdtab(false);
        setIsforthtab(false);
        setIsfifth(false);
        setDashbaordtab(false);
      }
    } else if (e === 2) {
      calllvdata();
      callhvdata();
      fetchsavedharnessdata();
      setIsfirsttab(false);
      setIsecondtab(true);
      setIsthirdtab(false);
      setIsforthtab(false);
      setIsfifth(false);
      setDashbaordtab(false);
    } else if (e === 3) {
      calllvconnectordata();
      setIsfirsttab(false);
      setIsecondtab(false);
      setIsthirdtab(true);
      setIsforthtab(false);
      setIsfifth(false);
      setDashbaordtab(false);
    } else if (e === 4) {
      callbondingdata();
      setIsfirsttab(false);
      setIsecondtab(false);
      setIsthirdtab(false);
      setIsforthtab(true);
      setIsfifth(false);
      setDashbaordtab(false);
    } else if (e === 5) {
      
     
      setIsfirsttab(false);
      setIsecondtab(false);
      setIsthirdtab(false);
      setIsforthtab(false);
      setIsfifth(true);
      setDashbaordtab(false);
    } else if (e === 6) {
      setIsfirsttab(false);
      setIsecondtab(false);
      setIsthirdtab(false);
      setIsforthtab(false);
      setIsfifth(false);
      setDashbaordtab(true);
    }
  };
  
  
  const fetchsavedcommissiondata = () => {
    axios({
      method: "get",
      url: GET_COMMISSIONDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        setCommissiondata(response.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const fetchlvdatafn=()=>{

  }
  const fetchsavedharnessdata = () => {
    axios({
      method: "get",
      url: GET_HARNESSDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        setSavedharnessdata(response.data.data)  
        setHarnesssaveddata(response.data.data);
        let totalharnessdata =response.data.data
        let objs={}
        let array=[]
        const filteredArr = totalharnessdata.reduce((acc, current) => {
          const x = acc.find(item => item.vin === current.vin );
          const y =acc.find(item => item.vin === current.vin && item.testname===current.testname&&current.remarks === "Yes");
          console.log(y)
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
        let obj = totalharnessdata.reduce((res, curr) =>
          {
              if (res[curr.vin])
                  res[curr.vin].push(curr);
              else
                  Object.assign(res, {[curr.vin]: [curr]});
          
              return res;
          }, {});
          
          console.log(obj);
          let objarray = Object.values(obj)
          let arraypart=[]
          for(var i = 0; i < objarray.length; i++){
          let obj2 = objarray[i].reduce((res, curr) =>
            {
                if (res[curr.testname])
                    res[curr.testname].push(curr);
                else
                    Object.assign(res, {[curr.testname]: [curr]});
            
                return res;
            }, {});
            arraypart.push(obj2)
            console.log(obj2);
          }
            
        console.log(arraypart)
        const filteredArred = arraypart.reduce((acc, current) => {
          const x = acc.find(item => item.vin === current.vin );         
          
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
        // console.log(result)
        console.log(filteredArr)
        var lvharnesslist=[]
        var hvharnesslist=[]
        for(var i = 0; i < filteredArr.length; i++){
          lvharnesslist.push(arraypart[i].lvharness)
          hvharnesslist.push(arraypart[i].hvharness)

        }
        console.log(lvharnesslist)
        console.log(hvharnesslist)
        for(var i = 0; i < lvharnesslist.length; i++){
          for(var j = 0; j < lvharnesslist[i].length; j++){
            if(lvharnesslist[i][j].remarks==="No"){
              lvharnesslist[i].push({Remarks:"No"})
              break
            }
          }
          for(var j = 0; j < hvharnesslist[i].length; j++){
            if(hvharnesslist[i][j].remarks==="No"){
              hvharnesslist[i].push({Remarks:"No"})
              break
            }
          }

        }
        console.log(lvharnesslist)
        console.log(hvharnesslist)
        setListlvharnessdata(lvharnesslist)

      })
      .catch((error) => {
        console.error(error);
      });
  };

    const clickAction = (val, data) => {
    handleShow(val, data);
  };

  const handleClose = () => setShow(false);
  
  const handleShow = (e, data) => {
    setRawdata(e);
    setSelectedempid(data.emp_id);
    setSelectedemailid(data.email_id);
    setEmpdata(data);

    setShow(true);
  };
  const handleChange = (event) => {
    setVinumber(event.target.value);
  };
  const callselectedfn = (e) => {
    setStep1cr(e.target.value);
    // setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
  };
  const callselectedfn2 = (e) => {
    setStep2cr(e.target.value);
    // setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
  };
  const callselectedfn3 = (e) => {
    setStep3cr(e.target.value);
    // setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
  };
  const callselectedfn4 = (e) => {
    setStep4cr(e.target.value);
    // setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
  };
  const callselectedfn5 = (e) => {
    setStep5cr(e.target.value);
    // setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
  };

  const callhvdata = (data) => {
    console.log(data);

    axios({
      method: "get",
      url: GET_FETCHHVDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { model: modelselect },
    })
      .then((response) => {
        // alert(response.data.data)
        let getdata = response.data.data;
        setHvdataobj(getdata);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const calllvdata = (data) => {
    console.log(data);

    axios({
      method: "get",
      url: GET_FETCHLVDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { model: modelselect },
    })
      .then((response) => {
        // alert(response.data.data)
        let getdata = response.data.data;
    //     let newArr =[]
    //    getdata.map(function (val, index) {
    //     getdata[index].push({qty:'',status:''})
    //         return ;
    //     })
    // let objs1={}
    // let objs2={
    //     qty:'1',
    //     status:''
    // }
    // let newarray=[]
    //         for(var i = 0; i < getdata.length; i++){
    //             objs1=getdata[i]
    //             Object.assign(objs1,objs2)
    //             newarray.push(objs1)
    //     }
        
        setLvdataobj(getdata);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const calllvconnectordata = (data) => {
    console.log(data);

    axios({
      method: "get",
      url: GET_FETCHLVCONDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { model: modelselect!=="EULE"?null:modelselect },
    })
      .then((response) => {
        // alert(response.data.data)
        let getdata = response.data.data;
        setLvcondataobj(getdata);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const callbondingdata = (data) => {
    console.log(data);

    axios({
      method: "get",
      url: GET_FETCHBONDINGDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
        
      },
      params: { model: modelselect },
    })
      .then((response) => {
        // alert(response.data.data)
        let getdata = response.data.data;
        setBondingobj(getdata);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handlesubmit=()=>{
    if(dop!==undefined){
      var textareas = document.getElementById("myTextarea").value;
      console.log(step1cr + step2cr + step3cr + step4cr + step5cr + textareas)
      let objs={};
      let commisioning;
      if(step1cr==="Yes" && step2cr==="Yes"&&step3cr==="Yes"&&step4cr==="Yes"&&step5cr==="Yes"){
          commisioning="complete"
      }else{
          commisioning="Yet to complete"
      }
      objs.model = modelselect;
      objs.vin = vinval;
      objs.dateoftest=dop;
      objs.material = textareas;
      objs.step1=step1cr
      objs.step2=step2cr
      objs.step3=step3cr
      objs.step4=step4cr
      objs.step5=step5cr
      objs.summary=commisioning;
      console.log(objs)
  
      axios.post(CREATE_COMMISSIONREPORT, [objs])
      .then(function (response) {
        //console.log("SuccessFully updated");
        alert(response.data);  
      })
        .catch(function (error) {
          console.log(error);
        });
    }else{
      alert("Please enter the date")
    }
   
  }

  const handlesubmitbonding=()=>{
    let setval;
    if(dop!==undefined){
      console.log(bondingmsg)
      for(var i = 0; i < bondingmsg.length; i++){
        if(bondingmsg[i].testvalue===undefined || bondingmsg[i].remarks===undefined || bondingmsg[i].vin===""){
          alert("Please select all the values")
          setval=false
          return
        }
    }
    if(setval!==false){
      callinsertbond(bondingmsg)
    }
    }else{
      alert("Please enter the date")
    }
  }

  const handlesubmitlvconnector = ()=>{
    console.log(lvcondataobj)
    let checkempty;
   for(var i = 0; i < lvcondataobj.length; i++){
        if(lvcondataobj[i].remarks===undefined ){
          alert("Please select all the values")
          checkempty=false
          return
        }
    }
    if(checkempty!==false){
      callinsertlvconfn(lvcondataobj)
    }
  }
  const handlesubmitlv=()=>{
    let setval;
    let setvalhv;
    console.log(lvdataobj)
    if(dop!==undefined){
    for(var i = 0; i < lvdataobj.length; i++){
        if(lvdataobj[i].qty===undefined || lvdataobj[i].remarks===undefined){
          alert("Please select all the values")
          setval=false
          return
        }
    }
    if(setval!==false){
      callinsertfn(lvdataobj)
    }
    for(var i = 0; i < hvdataobj.length; i++){
      if(hvdataobj[i].qty===undefined || hvdataobj[i].remarks===undefined){
        alert("Please select all the values")
        setvalhv=false
        return
      }
  }
  if(setvalhv!==false && setval!==false){
    callinsertfn(hvdataobj)
  }
    console.log(hvdataobj)
}else{
  alert("Please enter the date")
}

  }
  const callinsertfn=(objs)=>{

    axios.post(CREATE_TEST_ENTRY, objs)
    .then(function (response) {
      //console.log("SuccessFully updated");
      alert(response.data); 
      setLvdataobj([])
      setHvdataobj([])
    })
      .catch(function (error) {
        console.log(error);
      });
  }

  const callinsertlvconfn=(objs)=>{
    axios.post(CREATE_LV_CONNECTOR, objs)
    .then(function (response) {
      //console.log("SuccessFully updated");
      alert(response.data);  
    })
      .catch(function (error) {
        console.log(error);
      });
  }
  const callinsertbond=(objs)=>{
    axios.post(CREATE_BONDING, objs)
    .then(function (response) {
      //console.log("SuccessFully updated");
      alert(response.data);  
    })
      .catch(function (error) {
        console.log(error);
      });
  }
  const modelselelctfn=(e)=>{
    setModelselect(e.target.value)
  }
  const handleChangevin=(e)=>{
    setvinval(e.target.value)
  }
  
  const callhvqty=(e,v,j)=>{
    let objs1={}
    let objs2={
        qty:e.target.value,
       
    }
    let newarray=[]
    for(var i = 0; i < hvdataobj.length; i++){
        if(j===i){
            objs1=hvdataobj[j]
        Object.assign(objs1,objs2)
        }else{
            objs1 =hvdataobj[i]
        }
        newarray.push(objs1)
}
   
    setHvdataobj(newarray)
  }

  const calllvconnect=(e,v,j)=>{
    let objs1={}
    let objs2={
        remarks:e.target.value,
        testname:"lvconnector",
        model:modelselect,
        vin:vinval
       
    }
    let newarray=[]
    for(var i = 0; i < lvcondataobj.length; i++){
        if(j===i){
            objs1=lvcondataobj[j]
        Object.assign(objs1,objs2)
        }else{
            objs1 =lvcondataobj[i]
        }
        newarray.push(objs1)
}
   
    setLvcondataobj(newarray)
  }
  const calbondingremarks=(e,v,j)=>{
    let objs1={}
    let objs2={
        remarks:e.target.value,
        testname:"bonding string",
        model:modelselect,
        vin:vinval
       
    }
    let newarray=[]
    for(var i = 0; i < bondingobj.length; i++){
        if(j===i){
            objs1=bondingobj[j]
        Object.assign(objs1,objs2)
        }else{
            objs1 =bondingobj[i]
        }
        newarray.push(objs1)
}
   
    setBondingmsg(newarray)
  }
  const calbondingmsg=(e,v,j)=>{
    
    let objs1={}
    let objs2={
      testvalue:e.target.value,
        
       
    }
    let newarray=[]
    for(var i = 0; i < bondingobj.length; i++){
        if(j===i){
            objs1=bondingobj[j]
        Object.assign(objs1,objs2)
        }else{
            objs1 =bondingobj[i]
        }
        newarray.push(objs1)
}
   
      setBondingmsg(newarray)
  }
  const calllvqty=(e,v,j)=>{
    let objs1={}
    let objs2={
        qty:e.target.value,
       
    }
    let newarray=[]
    for(var i = 0; i < lvdataobj.length; i++){
        if(j===i){
            objs1=lvdataobj[j]
        Object.assign(objs1,objs2)
        }else{
            objs1 =lvdataobj[i]
        }
        newarray.push(objs1)
}
   
    setLvdataobj(newarray)
  }
  const callhvstatus=(e,v,j)=>{
    let objs1={}
    let objs2={
        remarks:e.target.value,
        testname:"hvharness",
        vin:vinval,
        model:modelselect,
       
    }
    let newarray=[]
    for(var i = 0; i < hvdataobj.length; i++){
        if(j===i){
            objs1=hvdataobj[j]
        Object.assign(objs1,objs2)
        }else{
            objs1 =hvdataobj[i]
        }
        newarray.push(objs1)
}
   
    setHvdataobj(newarray)
  }
  const calllvstatus=(e,v,j)=>{
    let objs1={}
    let objs2={
        remarks:e.target.value,
        testname:"lvharness",
        vin:vinval,
        model:modelselect,
       
    }
    let newarray=[]
    for(var i = 0; i < lvdataobj.length; i++){
        if(j===i){
            objs1=lvdataobj[j]
        Object.assign(objs1,objs2)
        }else{
            objs1 =lvdataobj[i]
        }
        newarray.push(objs1)
}
   
    setLvdataobj(newarray)
  }
  const callsubmenu=(val)=>{
    if(val===1){
      setIsfirstsub1(true)
      setIsfirstsub2(false)
    }else{
      fetchsavedcommissiondata()
      setIsfirstsub1(false)
      setIsfirstsub2(true)
    }

  }
  const callsubmenulvcon=(val)=>{
    if(val===1){
      setIsfirstsub3(true)
      
    }else{
      callbondingsaveddata()
      calllvconnectorsaveddata()
      setIsfirstsub3(false)
     
    }
  }

  const callsubiso=(val)=>{
    if(val===1){
      setIsfirstsub3(true)
      
    }else{
      callisoloationdata()
      setIsfirstsub3(false)
     
    }
  }
  const callsubmenulv=(val)=>{
    if(val===1){
      setIsfirstsublv1(true)
      setIsfirstsublv2(false)
    }else{
      fetchsavedharnessdata()
      setIsfirstsublv1(false)
      setIsfirstsublv2(true)
    }

  }
  const calculateresistance=()=>{
    let resistanceValue;
if(!vb||!vc||!vc2||!ro||!ro2||!ro1)
  {
    alert("Please fill all the value")
  }else{
    if(vc2>vc){
      resistanceValue=  ro*vb*((1/ro1)-(1/vc2))
    }else{
      resistanceValue=  ro*vb*((1/ro2)-(1/vc))
    }
    setResistancedata(resistanceValue)
}

  }

  const submitisolationtest=()=>{
    if(!dop||!modelselect||!vinval||!vb||!vc||!vc2||!ro||!ro2||!ro1)
      {
        alert("Please fill all the value")
      }else{
        callisolationfn()
      }
  }

  const callisolationfn=()=>{
    let idcondition= idealcondition
    let systemvoltage= vb
    let positivechassis= vc
    let positiveresistance= ro2
    let resistance= ro
    let negativechassis= vc2
    let negativeresistance= ro1
    let electricisolation = resistancedata
    let vin = vinval
    let model=modelselect
   
    axios.post(CREATE_ISOLATIONTEST, {idcondition,systemvoltage,positivechassis,positiveresistance,resistance,negativechassis,negativeresistance,vin,model,dop,electricisolation})
    .then(function (response) {
      //console.log("SuccessFully updated");
      alert(response.data);  
    })
      .catch(function (error) {
        console.log(error);
      });
  }

  const callindreport=(e,val)=>{
    // alert(val)
    setModelselect(val.model)
    setvinval(val.vin)
    setDop()
    setStep1cr(val.step1)
    setStep2cr(val.step2)
    setStep3cr(val.step3)
    setStep4cr(val.step4)
    setStep5cr(val.step5)
    setIsfirstsub1(true)
    setIsfirstsub2(false)
  }
  const calllvconnectorsaveddata = ()=>{
    axios({
      method: "get",
      url: GET_LVCONNECTORSAVEDDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      
    })
      .then((response) => {
        console.log(response.data.data)
        setLvconnectorsavedlist(response.data.data)
      }
    ).catch((error) => {
      console.error(error);
    });
  }

  const callbondingsaveddata = ()=>{
    axios({
      method: "get",
      url: GET_BONDINGSAVEDDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      
    })
      .then((response) => {
        console.log(response.data.data)
        setBondingsavedlist(response.data.data)
      }
    ).catch((error) => {
      console.error(error);
    });
  }

  const callisoloationdata=()=>{
    axios({
      method: "get",
      url: GET_ISOLATIONSAVEDDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      
    })
      .then((response) => {
        console.log(response.data.data)
        setIsolationsavedlist(response.data.data)
      }
    ).catch((error) => {
      console.error(error);
    });
  }
  

  const calllvconnectorselected=(e,val)=>{
    setModelselect(val.model)
    setvinval(val.vin)
    setDop()
    axios({
      method: "get",
      url: GET_LVCONNECTOR_EACH,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { vin: val.vin },
      
    })
      .then((response) => {
        let rawdata = response.data.data
        setLvcondataobj(response.data.data)
        setIsfirstsub3(true)
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const callbondingselected=(e,val)=>{
    setModelselect(val.model)
    setvinval(val.vin)
    setDop()
    axios({
      method: "get",
      url: GET_BONDING_EACH,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { vin: val.vin },
      
    })
      .then((response) => {
        let rawdata = response.data.data
        setBondingobj(response.data.data)
        setIsfirstsub3(true)
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const callisolationselected=(e,val)=>{
    setModelselect(val.model)
    setvinval(val.vin)
    setDop()
    axios({
      method: "get",
      url: GET_ISOLATION_EACH,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { vin: val.vin },
      
    })
      .then((response) => {
        let rawdata = response.data.data[0]
        setIdealcondition(rawdata.idcondition)
        setVb(rawdata.systemvoltage)
        setVc(rawdata.positivechassis)
        setVc2(rawdata.negativechassis)
        setRo(rawdata.resistance)
        setRo2(rawdata.positiveresistance)
        setRo1(rawdata.negativeresistance)
        setIsfirstsub3(true)
        calculateresistance()
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const callharnesstest=(e,val)=>{
    setModelselect(val.model)
    setvinval(val.vin)
    setDop()
    axios({
      method: "get",
      url: GET_HARNESSDATA_EACH,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { vin: val.vin },
      
    })
      .then((response) => {
        let rawdata = response.data.data
        let lvdata=[];
        let hvdata=[];
        for(var i = 0; i < rawdata.length; i++){
          if(rawdata[i].testname==="hvharness"){
            hvdata.push(rawdata[i])
          }else{
            lvdata.push(rawdata[i])
          }

        }
       console.log(lvdata)
       console.log(hvdata)
       setLvdataobj(lvdata)
       setHvdataobj(hvdata)
       setIsfirstsublv1(true)
        setIsfirstsublv2(false)

      })
      .catch((error) => {
        console.error(error);
      });
  }
  return (
    <div className="bg_set_eol">
      <div className="switch">
        <img
          className="switch-back"
          onClick={redirectTodashboard}
          src={imagebk}
        />
        <img className="switch-img" src={image} />
        <img
          className="logout-img"
          title="Logout"
          onClick={redirectToLogin}
          src={logoutimg}
        />
      </div>
      <br />
      <br />
      <div></div>
      <div>
        <div className="row tabdesigneol">
          <div
            className={
              dashbaordtab
                ? "col-md-1 tabfirst-selected"
                : "col-md-1 notselected"
            }
            onClick={() => enabletab(6)}
          >
            Dashboard{" "}
          </div>
          <div
            className={
              isfirsttab ? "col-md-2 tabfirst-selected" : "col-md-2 notselected"
            }
            onClick={() => enabletab(1)}
          >
            Commissioning sheet{" "}
          </div>
          <div
            className={
              issecondtab
                ? "col-md-1 tabfirst-selected"
                : "col-md-1 notselected"
            }
            onClick={() => enabletab(2)}
          >
            HV&LV Cables
          </div>
          <div
            className={
              isthirdtab ? "col-md-2 tabfirst-selected" : "col-md-2 notselected"
            }
            onClick={() => enabletab(3)}
          >
            LV connectors
          </div>
          <div
            className={
              isforthtab ? "col-md-3 tabfirst-selected" : "col-md-3 notselected"
            }
            onClick={() => enabletab(4)}
          >
            Bonding MSD & String Vltg
          </div>
          <div
            className={
              isfifth ? "col-md-1 tabfirst-selected" : "col-md-1 notselected"
            }
            onClick={() => enabletab(5)}
          >
            Isolation Test{" "}
          </div>
          {/*      */}
          {/* <div className="col-md-2 tabfour">View Request</div> */}
        </div>
        {/* table content  */}

        {isfirsttab ? (
             <>
          <div className="tabone_latout">
            <div className="row">
            <div onClick={() =>callsubmenu(1)} className={isfirstsub1?"col-md-1 subactive":"col-md-1"}>
            Create
            </div>
            <div onClick={() =>callsubmenu(2)} className={isfirstsub2?"col-md-1 subactive":"col-md-1"}>
            View
            </div>
            </div>
            {isfirstsub1?<div className="row">
            <div className="title-align">
                <label>ELECTRIC VEHICLE COMISSIONING REPORT </label>
              </div>
              <div className="row pb-2">
                <div className="col-md-1">
                  <p>Model: </p>
                </div>{" "}
                <div className="col-md-2">
                <select
                        name="select"
                        id="select"
                        value={modelselect}
                        onChange={(e) => modelselelctfn(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn === ""}
                        >
                          Select
                        </option>
                        <option value="9M DD">9M DD</option>
                        <option value="9M DOLVI">9M DOLVI</option>
                        <option value="9M INDORE">9M INDORE</option>
                        <option value="12M DOLVI">12M DOLVI</option>
                        <option value="12M VVC">12M VVC</option>
                        <option value="EULE">EULE</option>
                        <option value="MY24 - (189 KWh)">MY24 - (189 KWh)</option>
                        <option value="MY24 - (346KWh)">MY24 - (346 KWh)</option>
                        
                        
                       

                      </select>  
                </div>
                <div className="col-md-1">
                  <p>VIN: </p>
                </div>{" "}
                <div className="col-md-2">
                  <input
                    maxLength="17"
                    value={vinval}
                    type="Text"
                    placeholder="Enter VIN"
                    onChange={(e) => handleChangevin(e)}
                  />
                </div>
                <div className="col-md-1">
                  <p>Date:</p>
                </div>
                <div className="col-md-2">
                  <input
                   value={dop}
                    type="date"
                    onChange={(e) => setDop(e.target.value)}
                    id="birthday"
                    name="birthday"
                  />
                </div>
             
              <div>
                <textarea
                  id="myTextarea"
                  name="postContent"
                  defaultValue="Measuring instruments to be verified  before the start of commisioning : 
            Instrument Name: 
            1. Multimeter                                                                                                                                                                                                                                                                                                                                                                                                                            
            2. Ground bond tester  "
                  rows={4}
                  cols={40}
                />
                <textarea
                  className="textarea_design"
                  name="postContent"
                  defaultValue=" Warning : Without personal protective equipment (PPE), High voltage measurement not to be done on the vehicle in HV powerup condition "
                  // rows={2}
                  // cols={10}
                />
                {/* <textarea>
                Warning : Without personal protective equipment (PPE), High voltage measurement not to be done on the vehicle in HV powerup condition
                </textarea>                     */}
              </div>
              <div>
              <table className="table-full">
                <thead className="header-asset">
                  <tr>
                    <th>Steps No</th>
                    <th>Vehicle commissioning checks</th>
                    <th>Vehicle Condition</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Step 1</td>
                    <td>
                      High voltage cable verification - Refer HV Commissioning
                      Sheet
                    </td>
                    <td>Power Down</td>
                    <td>
                      <select
                        name="select"
                        id="select"
                        value={step1cr}
                        onChange={(e) => callselectedfn(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn === ""}
                        >
                          Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Step 2</td>
                    <td>
                      Bonding cable verification - Refer HV Commissioning Sheet
                    </td>
                    <td>Power Down</td>
                    <td>
                      <select
                        name="select"
                        id="select"
                        value={step2cr}
                        onChange={(e) => callselectedfn2(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn2 === ""}
                        >
                          Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Step 3</td>
                    <td>LV commissioning - Refer LV commissioning sheet</td>
                    <td>Power Down</td>
                    <td>
                      <select
                        name="select"
                        id="select"
                        value={step3cr}
                        onChange={(e) => callselectedfn3(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn3 === ""}
                        >
                          Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Step 4</td>
                    <td>Aux inverter & EVCU flashing (if required)</td>
                    <td>LV Power ON Condition</td>
                    <td>
                      <select
                        name="select"
                        id="select"
                        value={step4cr}
                        onChange={(e) => callselectedfn4(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn4 === ""}
                        >
                          Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Step 5</td>
                    <td>
                      Isolation Measurement - Refer Isolation Measurement Sheet
                      <br />
                      <p style={{ color: "red" }}>
                        Warning : Use Personal protective equipment(PPE) while
                        conducting measurements on HV power - up condition
                      </p>
                    </td>
                    <td>HV Power - up Condition</td>
                    <td>
                      <select
                        name="select"
                        id="select"
                        value={step5cr}
                        onChange={(e) => callselectedfn5(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn5 === ""}
                        >
                          Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table> 
              </div>             
            </div>  </div>:<div> <table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Model</th>
                  <th>VIN</th>
                  <th>Date</th>
                  {/* <th>Material</th> */}
                  <th>Step 1</th>
                  <th>Step 2</th>
                  <th>Step 3</th>
                  <th>Step 4</th>
                  <th>Step 5</th>
                  <th>Summary</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {commissiondata.length
                  ? commissiondata.map((val, i) => {
                      return (
                        <tr>
                          {/* <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> */}
                          <td>{i+1}</td>
                          <td>{val.model}</td>
                          <td>{val.vin}</td>
                          <td>{val.dateoftest}</td>
                          {/* <td>{val.material}</td> */}
                          <td>{val.step1}</td>
                          <td>{val.step2}</td>
                          <td>{val.step3}</td>
                          <td>{val.step4}</td>
                          <td>{val.step5}</td>
                          <td>{val.summary}</td>
                          <td style={{cursor:"pointer"}}onClick={(e)=>callindreport(e,val)}>View</td>
                        </tr>
                      );
                    })
                  : ""}
              </tbody>
            </table></div>   }    
          </div>
          {isfirstsub1?<div className="commnext">   
              <Button
                  variant="primary"
                  className="btns buttonitem1"
                  type="reset"
                  value="next"
                  onClick={() => handlesubmit()}
              >
                  Next
              </Button>
              </div>:''}
              
             </>
        ) : (
          ""
        )}
        {isthirdtab ? (
          <div className="Apps-asset scrolloption">
            <p> LV CONNECTORS CHECK SHEET : {modelselect}</p>
            <div className="row">
            <div onClick={() =>callsubmenulvcon(1)} className={isfirstsub3?"col-md-1 subactive":"col-md-1"}>
            Create
            </div>
            <div onClick={() =>callsubmenulvcon(2)} className={isfirstsub3?"col-md-1 ":"col-md-1 subactive"}>
            View
            </div>
            </div>
            {isfirstsub3?
            <>
            <div className="row">
          <div className="col-md-1">
                  <p>Model: </p>
                </div>{" "}
          <div className="col-md-2">
                <select
                        name="select"
                        id="select"
                        value={modelselect}
                        onChange={(e) => modelselelctfn(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn === ""}
                        >
                          Select
                        </option>
                        <option value="9M DD">9M DD</option>
                        <option value="9M DOLVI">9M DOLVI</option>
                        <option value="9M INDORE">9M INDORE</option>
                        <option value="12M DOLVI">12M DOLVI</option>
                        <option value="12M VVC">12M VVC</option>
                        <option value="EULE">EULE</option>
                        <option value="MY24 - (189 KWh)">MY24 - (189 KWh)</option>
                        <option value="MY24 - (346KWh)">MY24 - (346 KWh)</option>
                        
                        
                       

                      </select>  
                </div>
          <div className="col-md-1">
                  <p>VIN: </p>
                </div>{" "}
                <div className="col-md-2">
                  <input
                    maxLength="17"
                    value={vinval}
                    type="Text"
                    placeholder="Enter VIN"
                    onChange={(e) => handleChangevin(e)}
                  />
                </div>
                <div className="col-md-1">
                  <p>Date:</p>
                </div>
                <div className="col-md-2">
                  <input
                    value={dop}
                    type="date"
                    onChange={(e) => setDop(e.target.value)}
                    id="birthday"
                    name="birthday"
                  />
                </div>
                </div>
            <table className="table-full">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>CONNECTORS</th>
                  <th>REMARKS</th>
                </tr>
              </thead>
              <tbody>
                {lvcondataobj.length
                  ? lvcondataobj.map((val, i) => {
                      return (
                        <tr>
                          {/* <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> */}
                          <td>{i+1}</td>
                          <td>{val.description}</td>
                          <td> 
                        <select
                        name="select"
                        id="select"
                        value={val.remarks}
                        onChange={(e) => calllvconnect(e,val,i)}
                      >
                        <option
                          value=""                          
                          selected={val.remarks === ""}
                        >
                          Select
                        </option>
                        <option value="Not Connected">Not Connected</option>
                        <option value="Loose Condition">Loose Condition</option>
                        <option value="Not Fitted">Not Fitted</option>
                        <option value="Pin Back Out">Pin Back Out</option>
                        <option value="Wrong connection">Wrong connection</option>
                        <option value="Improper Connection">Improper Connection</option>
                        <option value="OK">OK</option>
                      </select></td>
                        </tr>
                      );
                    })
                  : ""}
              </tbody>
            </table>
            <div className="commnext">   
              <Button
                  variant="primary"
                  className="btns buttonitem1"
                  type="reset"
                  value="next"
                  onClick={() => handlesubmitlvconnector()}
              >
                  Next
              </Button>
              </div>
              </>:<div><table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Model</th>
                  <th>VIN</th>                              
                  <th>Date</th>
                  {/* <th>Material</th> */}
                  <th>Test name</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
              {lvconnectorsavedlist.length?lvconnectorsavedlist.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.model}</td>
                          <td>{val.vin}</td>
                          <td>{val.created_timestamp}</td>
                          <td>{val.testname}</td> 
                          <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>view</td>
                          
                        </tr>
                      );
                    })
                  : ""}
              
              </tbody>
            </table></div>}
          </div>
        ) : (
          ""
        )}
        {dashbaordtab ? (
          <div className="Apps-asset">
            <p> Summary</p>
            <table className="table-full">
              <thead className="header-asset">
                <tr>
                  <th>VIN</th>
                  <th>Commissioning sheet</th>
                  <th>HV&LV Cables</th>
                  <th>LV connectors</th>
                  <th>Bonding MSD & String Vltg</th>
                  <th>Isolation Test</th>
                  <th>Status</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>P5FAA4UE2RRJA0338</td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#c5bdbd" }}></td>
                  <td style={{ background: "#c5bdbd" }}></td>
                  <td style={{ background: "#c5bdbd" }}></td>
                  <td style={{ background: "#c5bdbd" }}></td>
                  <td>In progress</td>
                  <td>yet to start</td>
                </tr>
                <tr>
                  <td>P5FAA4UE4RRJA0342</td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "red" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "Red" }}></td>
                  <td>In progress</td>
                  <td>Pending in Isolation test</td>
                </tr>
                <tr>
                  <td>P5FAA4UE7RRJA0349</td>
                  <td style={{ background: "Red" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td>In progress</td>
                  <td>Pending in Commissioning test</td>
                </tr>
                <tr>
                  <td>P5FAA4UE7RRJA0349</td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td>Completed</td>
                  <td>Approved</td>
                </tr>
                <tr>
                  <td>P5FAA4UE7RRJA0349</td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td style={{ background: "#05c637" }}></td>
                  <td>Completed</td>
                  <td>Approved</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          ""
        )}
        {/* End of Table content */}
        {isforthtab ? (
          <div className="Apps-asset scrolloption">
            <p> BONDING TEST : {modelselect}</p>
            <p> BONDING VALUE 1mΩ = 0.001Ω</p>
            <div className="row">
            <div onClick={() =>callsubmenulvcon(1)} className={isfirstsub3?"col-md-1 subactive":"col-md-1"}>
            Create
            </div>
            <div onClick={() =>callsubmenulvcon(2)} className={isfirstsub3?"col-md-1 ":"col-md-1 subactive"}>
            View
            </div>
            </div>
            {isfirstsub3?
            <> <div className="row">
            <div className="col-md-1">
                    <p>Model: </p>
                  </div>{" "}
            <div className="col-md-2">
                  <select
                          name="select"
                          id="select"
                          value={modelselect}
                          onChange={(e) => modelselelctfn(e)}
                        >
                          <option
                            value=""
                            disabled
                            selected={callselectedfn === ""}
                          >
                            Select
                          </option>
                          <option value="9M DD">9M DD</option>
                          <option value="9M DOLVI">9M DOLVI</option>
                          <option value="9M INDORE">9M INDORE</option>
                          <option value="12M DOLVI">12M DOLVI</option>
                          <option value="12M VVC">12M VVC</option>
                          <option value="EULE">EULE</option>
                          <option value="MY24 - (189 KWh)">MY24 - (189 KWh)</option>
                          <option value="MY24 - (346KWh)">MY24 - (346 KWh)</option>
                        </select>  
                  </div>
            <div className="col-md-1">
                    <p>VIN: </p>
                  </div>{" "}
                  <div className="col-md-2">
                    <input
                      maxLength="17"
                      value={vinval}
                      type="Text"
                      placeholder="Enter VIN"
                      onChange={(e) => handleChangevin(e)}
                    />
                  </div>
                  <div className="col-md-1">
                    <p>Date:</p>
                  </div>
                  <div className="col-md-2">
                    <input
                      value={dop}
                      type="date"
                      onChange={(e) => setDop(e.target.value)}
                      id="birthday"
                      name="birthday"
                    />
                  </div>
                  </div>  
              {vinval!==""?<table className="table-full">
                <thead className="header-asset">
                  <tr>
                    <th>Sl.No</th>
                    <th>PART No</th>
                    <th>DESCRIPTION</th>
                    <th>VALUE</th>
                    <th>REMARKS</th>
                  </tr>
                </thead>
                <tbody>
                  {bondingobj.length
                    ? bondingobj.map((val, i) => {
                        return (
                          <tr>
                            {/* <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> */}
                            <td>{i+1}</td>
                            <td>{val.partno}</td>
                            <td>{val.description}</td>
                            <td><input
                          type="number"
                          name="lastname"
                          id="lastname"
                          value={val.testvalue}
                          onChange={(e) => calbondingmsg(e,val,i)}
                          placeholder=""
                          required
                          maxlength="30"
                      /></td>
                            <td><input
                          type="text"
                          name="lastname"
                          id="lastname"
                          value={val.remarks}
                          onChange={(e) => calbondingremarks(e,val,i)}
                          placeholder=""
                          required
                          maxlength="30"
                      /></td>
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </table>:''}
              <div className="commnext">   
                <Button
                    variant="primary"
                    className="btns buttonitem1"
                    type="reset"
                    value="next"
                    onClick={() => handlesubmitbonding()}
                >
                    Next
                </Button>
                </div></>:<div><table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Model</th>
                  <th>VIN</th>                              
                  <th>Date</th>
                  {/* <th>Material</th> */}
                  <th>Test name</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
              {bondingsavedlist.length?bondingsavedlist.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.model}</td>
                          <td>{val.vin}</td>
                          <td>{val.created_timestamp}</td>
                          <td>{val.testname}</td> 
                          <td style={{cursor:"pointer"}}onClick={(e)=>callbondingselected(e,val)}>view</td>
                          
                        </tr>
                      );
                    })
                  : ""}
              
              </tbody>
            </table></div>
           }
            
          </div>
        ) : (
          ""
        )}
      </div>
      {/* Asset master  */}
      {issecondtab ? (
        <div className="Apps-asset scrolloption">
           <div className="row">
          <div onClick={() =>callsubmenulv(1)} className={isfirstsublv1?"col-md-1 subactive":"col-md-1"}>
            Create
            </div>
            <div onClick={() =>callsubmenulv(2)} className={isfirstsublv2?"col-md-1 subactive":"col-md-1"}>
            View
            </div>
            </div>
          <p>LV HARNESS : {modelselect}</p>
          {isfirstsublv1?<>
          <div className="row">
          <div className="col-md-1">
                  <p>Model: </p>
                </div>{" "}
          <div className="col-md-2">
                <select
                        name="select"
                        id="select"
                        value={modelselect}
                        onChange={(e) => modelselelctfn(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn === ""}
                        >
                          Select
                        </option>
                        <option value="9M DD">9M DD</option>
                        <option value="9M DOLVI">9M DOLVI</option>
                        <option value="9M INDORE">9M INDORE</option>
                        <option value="12M DOLVI">12M DOLVI</option>
                        <option value="12M VVC">12M VVC</option>
                        <option value="EULE">EULE</option>
                        <option value="MY24 - (189 KWh)">MY24 - (189 KWh)</option>
                        <option value="MY24 - (346KWh)">MY24 - (346 KWh)</option>
                        
                        
                       

                      </select>  
                </div>
          <div className="col-md-1">
                  <p>VIN: </p>
                </div>{" "}
                <div className="col-md-2">
                  <input
                    maxLength="17"
                    value={vinval}
                    type="Text"
                    placeholder="Enter VIN"
                    onChange={(e) => handleChangevin(e)}
                  />
                </div>
                <div className="col-md-1">
                  <p>Date:</p>
                </div>
                <div className="col-md-2">
                  <input
                    value={dop}
                    type="date"
                    onChange={(e) => setDop(e.target.value)}
                    id="birthday"
                    name="birthday"
                  />
                </div>
                </div>
          <table className="table-full">
            <thead className="header-asset">
              <tr>
                <th>Sl.No</th>
                <th>PART No</th>
                <th>DESCRIPTION</th>
                <th>QTY</th>
                <th>REMARKS</th>
              </tr>
            </thead>
            <tbody>
              {lvdataobj.length
                ? lvdataobj.map((val, i) => {
                    return (
                      <tr>
                        {/* <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> */}
                        <td>{i+1}</td>
                        <td>{val.partno}</td>
                        <td>{val.description}</td>
                        <td> 
                        <select
                        name="select"
                        id="select"
                        value={val.qty}
                        onChange={(e) => calllvqty(e,val,i)}
                      >
                        <option
                          value=""                          
                          selected={val.qty === ""}
                        >
                          Select
                        </option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                      </select></td>
                        <td><select
                        name="select"
                        id="select"
                        value={val.status!==undefined?val.status:val.remarks}
                        onChange={(e) => calllvstatus(e,val,i)}
                      >
                        <option
                          value=""
                          selected={val.status === ""}
                        >
                          Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select></td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </table>
          <p style={{ marginTop: "3%" }}>HV CABLES : {modelselect}</p>
          <table className="table-full">
            <thead className="header-asset">
              <tr>
                <th>Sl.No</th>
                <th>PART No</th>
                <th>DESCRIPTION</th>
                <th>QTY</th>
                <th>REMARKS</th>
              </tr>
            </thead>
            <tbody>
              {hvdataobj.length
                ? hvdataobj.map((val, i) => {
                    return (
                      <tr>
                        {/* <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> */}
                        <td>{i+1}</td>
                        <td>{val.partno}</td>
                        <td>{val.description}</td>
                        <td> 
                        <select
                        name="select"
                        id="select"
                        value={val.qty}
                        onChange={(e) => callhvqty(e,val,i)}
                      >
                        <option
                          value=""                          
                          selected={val.qty === ""}
                        >
                          Select
                        </option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                      </select></td>
                        <td><select
                        name="select"
                        id="select"
                        value={val.status!==undefined?val.status:val.remarks}
                        onChange={(e) => callhvstatus(e,val,i)}
                      >
                        <option
                          value=""
                          selected={val.status === ""}
                        >
                          Select
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select></td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </table>
          <div className="commnext">   
              <Button
                  variant="primary"
                  className="btns buttonitem1"
                  type="reset"
                  value="next"
                  onClick={() => handlesubmitlv()}
              >
                  Next
              </Button>
              </div>
              </>:<>
                  <div><table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Model</th>
                  <th>VIN</th>                              
                  <th>Date</th>
                  {/* <th>Material</th> */}
                  <th>Test name</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
              {savedharnessdata.length?savedharnessdata.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.model}</td>
                          <td>{val.vin}</td>
                          <td>{val.created_timestamp}</td>
                          <td>LVHarness/HVHarness</td> 
                          <td style={{cursor:"pointer"}}onClick={(e)=>callharnesstest(e,val)}>view</td>
                          
                        </tr>
                      );
                    })
                  : ""}
                {/*listlvharnessdata.length
                  ? listlvharnessdata.map((val, i) => {
                      return (
                        <tr>
                          <td style={{width:"10%"}}><input onChange={(e)=>checkedval(e,i)} type="checkbox" /> </td> 
                          <td>{i+1}</td>
                          <td>{val[0].model}</td>
                          <td>{val[0].vin}</td>
                          <td>{val[0].created_timestamp}</td>
                          <td>{val.material}</td> }
                          <td>{val.map((vals,e)=>{
                            return(
                              vals.remarks==="No"?"No":"Yes"
                            )
                          }).Remarks}</td>
                          
                        </tr>
                      );
                    })
                  : ""*/}
              </tbody>
            </table></div>
              </>}
        </div>
        
      ) : (
        ""
      )}
      {isfifth ? (
        <div className="Apps-asset">
          <p>ISOLATION RESISTANCE TEST REPORT - {modelselect}</p>
          <div className="row">
            <div onClick={() =>callsubiso(1)} className={isfirstsub3?"col-md-1 subactive":"col-md-1"}>
            Create
            </div>
            <div onClick={() =>callsubiso(2)} className={isfirstsub3?"col-md-1 ":"col-md-1 subactive"}>
            View
            </div>
            </div>
            {isfirstsub3?
            <>
          <div className="row">
          <div className="col-md-1">
                  <p>Model: </p>
                </div>{" "}
          <div className="col-md-2">
                <select
                        name="select"
                        id="select"
                        value={modelselect}
                        onChange={(e) => modelselelctfn(e)}
                      >
                        <option
                          value=""
                          disabled
                          selected={callselectedfn === ""}
                        >
                          Select
                        </option>
                        <option value="9M DD">9M DD</option>
                        <option value="9M DOLVI">9M DOLVI</option>
                        <option value="9M INDORE">9M INDORE</option>
                        <option value="12M DOLVI">12M DOLVI</option>
                        <option value="12M VVC">12M VVC</option>
                        <option value="EULE">EULE</option>
                        <option value="MY24 - (189 KWh)">MY24 - (189 KWh)</option>
                        <option value="MY24 - (346KWh)">MY24 - (346 KWh)</option>
                        
                        
                       

                      </select>  
                </div>
          <div className="col-md-1">
                  <p>VIN: </p>
                </div>{" "}
                <div className="col-md-2">
                  <input
                    maxlength="17"
                    value={vinval}
                    type="Text"
                    placeholder="Enter VIN"
                    onChange={(e) => handleChangevin(e)}
                  />
                </div>
                <div className="col-md-1">
                  <p>Date:</p>
                </div>
                <div className="col-md-2">
                  <input
                    value={dop}
                    type="date"
                    onChange={(e) => setDop(e.target.value)}
                    id="birthday"
                    name="birthday"
                  />
                </div>
                </div>
          <p style={{ fontSize: "10px" }}>
            <strong>
              Procedure: Reference standard : AIS-038(Rev.1):2015{" "}
            </strong>
          </p>
          <ol style={{ fontSize: "10px", textAlign: "left" }}>
            <li>
              Isolation test is done in ON condition of the Vehicle , to ensure
              there is no leak current. ( the value should be above 500 ohms )
            </li>
            <li>
              This test is most critical test so the respected person should do
              the test with proper PPE.( Insulated rubber gloves should be
              ensured with double triangle symbole and capacity of withstand
              1000V )
            </li>
            <li>
              The resistance value is calculated with and without the resistor.
            </li>
            <li>
              At first, Measure system Voltage (Vb) (the refernce probe should
              be placed in positive terminal of PDB and other probe should be
              placed on negative terminal without resistor).
            </li>
            <li>
              In Second step, we have to check resistance value between Positive
              to chassis (V2) without resistor.
            </li>
            <li>
              {" "}
              In third step, measure the resistance value between negative to
              chassis(V1)
            </li>
            <li>
              Connect resistor in the multimeter probe ( the resistor value
              should be above 375 kohm)
            </li>
            <li>
              If V1 is greater than or equal to V2, insert a standard known
              resistance (RO) between the negative side of the high voltage bus
              and the electrical chassis. With RO installed, measure the voltage
              (V1’) between the negative side of the high voltage bus and the
              electrical chassis. Calculate the electrical isolation (Ri)
              according to this formula ( Ri = Ro*Vb* (1/V1' - 1/V1) (OR) If V2
              is greater than V1, insert a standard known resistance (Ro)
              between the positive side of the high voltage bus and the
              electrical chassis. With Ro installed, measure the voltage (V2’)
              between the positive side of the high voltage bus and the
              electrical chassis. Calculate the electrical isolation (Ri)
              according to this formula ( Ri = Ro*Vb* (1/V2' - 1/V2))
              <br /> Where
              <br />
              Vb - Battery measured value
              <br />
              Ro - Resistor value used as the base
              <br />
              V1- Negative to chassis ( without resistor)
              <br />
              V2- Positive to chassis (without resistor)
              <br />
              V1' - Negative to chassis ( with resistor)
              <br />
              V2' - Positive to chassis (with resistor)
            </li>
            <li>
              The value of Isolation Resistance is calculated as Ri/Vb (kohms/V)
            </li>
            <li>
              The calculated value should be above 500 omhs, to ensure there is
              no presence of leak current in the vehicle.{" "}
            </li>
            <li>Accetance Resistance value : greater than 500 Ohm</li>
            <li>
              The value mention here is taken manually in the PDB (Vehicle on
              condition)
            </li>
          </ol>

          <table className="table-full">
            <thead className="header-asset">
              <tr>
                <th>Sl.No</th>
                <th>Condition</th>
                <th>Measured voltage (v)</th>
                <th>REMARKS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Ideal Condition</td>
                <td><input
                        type="number"
                        name="lastname"
                        id="lastname"
                        value={idealcondition}
                        onChange={(e) =>
                            setIdealcondition(e.target.value)
                        }
                        placeholder=""
                        required
                        maxlength="30"
                    /></td>
              
              </tr>
              <tr>
                <td>2</td>
                <td>System Voltage (Vb)</td>
                <td><input
                        type="number"
                        name="lastname"
                        id="lastname"
                        value={vb}
                        onChange={(e) =>
                            setVb(e.target.value)
                        }
                        placeholder=""
                        required
                        maxlength="30"
                    /></td>
                
              </tr>
              <tr>
                <td>3</td>
                <td>Positive to chassis (V2)</td>
                <td><input
                        type="number"
                        name="lastname"
                        id="lastname"
                        value={vc}
                        onChange={(e) =>
                            setVc(e.target.value)
                        }
                        placeholder=""
                        required
                        maxlength="30"
                    /></td>
                
              </tr>
              <tr>
                <td>4</td>
                <td>Negative to chassis (V1)</td>
                <td><input
                        type="number"
                        name="lastname"
                        id="lastname"
                        value={vc2}
                        onChange={(e) =>
                            setVc2(e.target.value)
                        }
                        placeholder=""
                        required
                        maxlength="30"
                    /></td>
                Resistance value:{parseFloat(resistancedata).toFixed(2)}
              </tr>
              <tr>
                <td>5</td>
                <td>Connect resistor in the multimeter probe (Ro) (Kohms)</td>
                <td><input
                        type="number"
                        name="lastname"
                        id="lastname"
                        value={ro}
                        onChange={(e) =>
                            setRo(e.target.value)
                        }
                        placeholder=""
                        required
                        maxlength="30"
                    /></td>
                
              </tr>
              <tr>
                <td>6</td>
                <td>R0 Resistor connected ( Positive to chassis (V2') )</td>
                <td><input
                        type="number"
                        name="lastname"
                        id="lastname"
                        value={ro2}
                        onChange={(e) =>
                            setRo2(e.target.value)
                        }
                        placeholder=""
                        required
                        maxlength="30"
                    /></td>
               
              </tr>
              <tr>
                <td>7</td>
                <td>R0 Resistor connected (Negative to chassis ( V1') )</td>
                <td><input
                        type="number"
                        name="lastname"
                        id="lastname"
                        value={ro1}
                        onChange={(e) =>
                            setRo1(e.target.value)
                        }
                        placeholder=""
                        required
                        maxlength="30"
                    /></td>
               
              </tr>
              
            </tbody>
          </table>
          <div className="col-md-12">  
          
          <div className="cal-block ml-1">  
          <Button
                  variant="primary"
                  className="btns buttonitem1"
                  type="reset"
                  value="next"
                  onClick={() => calculateresistance()}
              >
                  Click to caluculate
              </Button>
              </div>
              <div className="cal-block">
              <Button
                  variant="primary"
                  className="btns buttonitem1"
                  type="reset"
                  value="next"
                  onClick={() => submitisolationtest()}
              >
                  Submit
              </Button>
              </div>
              </div></>:<div><table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Model</th>
                  <th>VIN</th>                              
                  <th>Date</th>
                  {/* <th>Material</th> */}
                  {/* <th>Test name</th> */}
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
              {isolationsavedlist.length?isolationsavedlist.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.model}</td>
                          <td>{val.vin}</td>
                          <td>{val.created_timestamp}</td>
                          <td style={{cursor:"pointer"}}onClick={(e)=>callisolationselected(e,val)}>view</td>
                          
                        </tr>
                      );
                    })
                  : ""}
              
              </tbody>
            </table></div>}
        </div>
      ) : (
        ""
      )}
      {/*  Modal  */}
    </div>
  );
}

export default Landing;
